/**
 * Using 3rd party react-datetime library for rendering calenders and clocks
 * Docs: [link](https://github.com/arqex/react-datetime/blob/2a83208452ac5e41c43fea31ef47c65efba0bb56/README.md)
 */

import React, { Fragment } from "react"
import { TIME_FORMAT } from "../../../../utilities/constants.js"

import { useFormikContext } from "formik"
import moment from "moment"
import DateTime from "react-datetime"
import "react-datetime/css/react-datetime.css"
import { getInNested } from "../dynamic-form.helper"

function InputTime(props) {
  const { id, label, name, placeholder, errorMessage, fieldData, isNestedFieldName, isRequired, ...otherProps } = props
  const { values, touched, errors, setFieldValue } = useFormikContext()
  const normalizedNameKey = isNestedFieldName ? name : `['${name}']`
  return (
    <Fragment>
      <div className="form-block-wrapper">
        <div className="custom-form-block flex-grow-1">
          <label htmlFor={id} className="form-label">
            {label} {isRequired && <sup>*</sup>}
          </label>
          <div className="input-group custom-field has-validation">
            <DateTime
              inputProps={{
                name,
                id,
                placeholder,
                className: `form-control ${
                  getInNested(touched, name, isNestedFieldName) && getInNested(errors, name, isNestedFieldName) ? "is-invalid" : ""
                }`,
                readOnly: true,
              }}
              closeOnSelect={true}
              closeOnClickOutside={true}
              dateFormat={false}
              timeFormat={TIME_FORMAT}
              value={getInNested(values, name, isNestedFieldName)}
              onOpen={() => (touched[name] = true)}
              onChange={(timeValue) => {
                setFieldValue(normalizedNameKey, moment(timeValue).format(TIME_FORMAT))
              }}
            />
            <span
              className="icon-wrapper input-field-icon clickable"
              onClick={() => {
                document.getElementById(id).click()
              }}
            >
              <i className="fa-solid fa-clock"></i>
            </span>
          </div>
          <div className="invalid-feedback">
            {getInNested(touched, name, isNestedFieldName) && getInNested(errors, name, isNestedFieldName) ? errorMessage : ""}
          </div>
        </div>
      </div>
    </Fragment>
  )
}

InputTime.propTypes = {}

export default InputTime
